const voteRatings = {
  UPVOTE: 'thumbs_up',
  DOWNVOTE: 'thumbs_down'
};

export const useChatbotVote = async (messageId, vote) => {
  const rating = voteRatings[vote];
  if (!rating) return { success: false, error: new Error('Invalid chatbot vote') };

  const cosmo = useCosmo();
  const messageIndex = cosmo.conversation.findIndex((message) => message.id === messageId);
  const message = cosmo.conversation[messageIndex];
  const { data, error } = await useApiV3().post('/chatbot/feedback', {
    session_id: cosmo.sessionId,
    message_id: messageId,
    ...(messageIndex >= 0 && { message_index: messageIndex }),
    ...(message?.content && { message_preview: message.content.slice(0, 200) }),
    rating
  });

  return {
    success: !error,
    error,
    feedback: data?.feedback
  };
};
